import styled from 'styled-components'
import { tokens } from '@/client/components/theme'
import borders from '@/client/components/theme/borders'
import color from '@/client/components/theme/color'
import space from '@/client/components/theme/space'
const { breakpoint } = tokens

export const ProgressContainer = styled.div`
  overflow: hidden;
  position: relative;
  text-align: center;
  border-radius: 0.375rem;
  border-width: 2px;
  cursor: pointer;
  width: 100%;
  height: 100%;
`

export const DropArea = styled.div<{ activeDND: boolean; isError: boolean }>(
  ({ activeDND, isError }) => `
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${space.md} ${space.sm};
  border-radius: ${borders.radius.lg};
  border-width: ${borders.sizes.md};
  border-style: solid;
  border-color: ${isError ? color.danger.pure : color.primary.dark};
  text-align: center;
  background-color: ${activeDND ? color.neutral.dark : color.grayscale.lighter};
  height: 130px;
  width: 100%;
  @media (min-width: ${breakpoint.lg}) {
    width: 100%;
  }

  & button{
  margin-right: 0;
  }
`
)

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`
